import { render, staticRenderFns } from "./score-bar.vue?vue&type=template&id=088a9f01&scoped=true"
import script from "./score-bar.vue?vue&type=script&lang=js"
export * from "./score-bar.vue?vue&type=script&lang=js"
import style0 from "./score-bar.vue?vue&type=style&index=0&id=088a9f01&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088a9f01",
  null
  
)

export default component.exports